import React from "react";
import { Link } from "react-router-dom";

const CTAButton = ({
  children,
  to,
  primary = true,
  className = "",
  external = false,
}) => {
  const baseClasses = `
    inline-block px-6 py-3 rounded-md font-medium transition-all duration-300
    transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2
  `;

  const primaryClasses = `
    bg-psa-green-600 hover:bg-psa-green-700 text-white
    focus:ring-psa-green-500
  `;

  const secondaryClasses = `
    bg-white hover:bg-gray-100 text-psa-green-600 border border-psa-green-600
    focus:ring-psa-green-500
  `;

  const classes = `${baseClasses} ${
    primary ? primaryClasses : secondaryClasses
  } ${className}`;

  if (external) {
    return (
      <a
        href={to}
        className={classes}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {children}
    </Link>
  );
};

export default CTAButton;
